export const DISEASES = [
  { label: 'Cardiologist',  icon: 'fa-heart-pulse' },
  { label: 'Dermatologist', icon: 'fa-hand-dots' },
  { label: 'Ophthalmologist', icon: 'fa-eye' },
  { label: 'Orthopedic',    icon: 'fa-bone' },
  { label: 'Dentist',       icon: 'fa-tooth' },
  { label: 'Pediatrician',  icon: 'fa-baby' },
  { label: 'Gynecologist',  icon: 'fa-venus' },
  { label: 'ENT Specialist',icon: 'fa-ear-listen' },
];

export const CHECKUP_TYPES = [
  { label: 'X-Ray',        icon: 'fa-x-ray' },
  { label: 'CT Scan',      icon: 'fa-brain' },
  { label: 'MRI Scan',     icon: 'fa-magnet' },
  { label: 'Ultrasound',   icon: 'fa-wave-square' },
  { label: 'Blood Test',   icon: 'fa-droplet' },
  { label: 'ECG',          icon: 'fa-heart' },
  { label: 'Full Body',    icon: 'fa-person' },
  { label: 'Diabetes',     icon: 'fa-syringe' },
];

export const APPOINTMENT_STATUSES = ['pending','confirmed','checked-in','completed','cancelled'];

export const PAYMENT_METHODS = [
  { value: 'upi',        label: 'UPI',               icon: 'fa-mobile-screen-button' },
  { value: 'card',       label: 'Credit / Debit Card',icon: 'fa-credit-card' },
  { value: 'netbanking', label: 'Net Banking',        icon: 'fa-building-columns' },
];

export const RAZORPAY_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';
